import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Waiting } from '../../components';
import { getUserRewardDetails } from '../../redux/actions/peopleHomeActions';
import { withTranslation } from 'react-i18next';
import RewardDetailsPage from '../../containers/Rewards/RewardDetailsPage';
import { TopContainerWrapper } from '../Recognition/RecognitionActivity/styles';
import { TabsWrapper } from '../common/commonStyles';
import { BorderBottom, TabBottomLine } from '../RecogntionAdmin/styles';
import CompanyRewardDetails from '../../containers/companyDetails/CompanyRewardDetails';
import { http } from '../../redux/http';
import BucketCaps from '../UserProfile/BucketCaps';

class AdminAchievementPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      firstIndex: 0,
      secondIndex: 0,
      companyId: props?.userProfileCompany?.company_details?.id,
      authtoken: props?.setUserDetails['auth_token'],
      rewardPeriodId: null,
      isCapEnabled: false,
    }
  }

  setActiveTab = (active) => {
    this.setState({ selectedTab: Number(active) })
  }

  async componentDidMount() {
    this.setState({ firstIndex: 10, secondIndex: 5 });
    const { getUserRewardDetails } = this.props;
    
    // Extract userId from URL path (admin viewing another user)
    const pathParts = window.location.pathname.split("/");
    const viewedUserId = pathParts[3];
    window.console.log('Viewing user ID from URL:', viewedUserId);  // add this
    window.console.log('Full pathname:', window.location.pathname);
    getUserRewardDetails(viewedUserId);

    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`/v1/get-user-reward-details?user_id=${viewedUserId}`, {
        headers: { AUTHTOKEN: AuthToken }
      });
      this.setState({
        isCapEnabled: res?.is_cap_enabled || false,
        rewardPeriodId: res?.reward_period_id,
      });
    } catch (e) {
      // silently fail
    }
  }

  render() {
    const { reward, brandingColor } = this.props;
    const { selectedTab, isCapEnabled, rewardPeriodId } = this.state;
    
    // Extract userId from URL for passing to child components
    const pathParts = window.location.pathname.split("/");
    const viewedUserId = parseInt(pathParts[3], 10);
    
    if (!reward) {
      return <Waiting />
    }
   
    return (
      <div>
        <TopContainerWrapper style={{ flexWrap: "wrap" }}>
          <TabsWrapper background="transparent" padding="20px 0 0 0 ">
            <TabBottomLine isPadding={"0px"} background={brandingColor} active={selectedTab==1} onClick={()=>this.setActiveTab(1)}>
              {"Points"}
              <BorderBottom active={selectedTab==1} background={brandingColor} />
            </TabBottomLine>
            {isCapEnabled && (
              <TabBottomLine isPadding={"0px"} background={brandingColor} active={selectedTab==3} onClick={()=>this.setActiveTab(3)}>
                {"Points Bucket"}
                <BorderBottom active={selectedTab==3} background={brandingColor} />
              </TabBottomLine>
            )}
            <TabBottomLine isPadding={"0px"} background={brandingColor} active={selectedTab==2} onClick={()=>this.setActiveTab(2)}>
              {"Company Rewards"}
              <BorderBottom active={selectedTab==2} background={brandingColor} />
            </TabBottomLine>
          </TabsWrapper>
        </TopContainerWrapper> 
        { selectedTab === 1 ? <RewardDetailsPage admin /> : null }
        { selectedTab === 2 ? <CompanyRewardDetails admin/> : null }
        { selectedTab === 3 && rewardPeriodId ? (
          <div style={{ paddingTop: '20px' }}>
            <BucketCaps rewardPeriodId={rewardPeriodId} userId={viewedUserId} />
          </div>
        ) : null }
      </div>
    );
  }
}

AdminAchievementPage.propTypes = {
  reward: PropTypes.object,
  monthlyRewardPoint: PropTypes.number,
  fitnessDetails: PropTypes.array,
  socialDetails: PropTypes.array,
  wellnessDetails: PropTypes.array,
  educationDetails: PropTypes.array,
  bonusWellness: PropTypes.array,
  bonusSocial: PropTypes.array,
  getUserRewardDetails: PropTypes.func,
  history: PropTypes.object,
  bonusFitness: PropTypes.array,
  bonusEducation: PropTypes.array,
  t: PropTypes.func,
  companyId: PropTypes.number,
  setUserDetails: PropTypes.array,
  userId: PropTypes.number,
  monthlyAdminRewardPoint: PropTypes.number,
  selectdUserAuth: PropTypes.string,
  userProfileCompany: PropTypes.array,
  brandingColor:PropTypes.string,
  companyBranding: PropTypes.object
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  fitnessDetails: state.wellnessDashboard.fitnessDetails,
  socialDetails: state.wellnessDashboard.socialDetails,
  wellnessDetails: state.wellnessDashboard.wellnessDetails,
  educationDetails: state.wellnessDashboard.educationDetails,
  bonusWellness: state.wellnessDashboard.bonusWellness,
  bonusSocial: state.wellnessDashboard.bonusSocial,
  bonusFitness: state.wellnessDashboard.bonusFitness,
  bonusEducation: state.wellnessDashboard.bonusEducation,
  monthlyAdminRewardPoint: state.wellnessDashboard.monthlyAdminRewardPoint,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
  brandingColor:state.wellnessDashboard.brandingColor,
});

const mapDispathcToProps = (dispatch) => ({
  getUserRewardDetails: (userId) => dispatch(getUserRewardDetails(userId)),
})

export default connect(mapStateToProps, mapDispathcToProps)(withTranslation()(AdminAchievementPage));
